import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NavController, NavParams, App } from 'ionic-angular';
import { CurrentAccount } from '../../app/models/CurrentAccount';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { Utils } from '../../providers/paytron-backend/utils';
import { Card } from '../../app/models/Card';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { HttpErrorResponse } from '@angular/common/http';
import { CardStatus } from '../../app/models/CardStatus';
import { CardBlockReason } from '../../app/models/CardBlockReason';
import { TableDirective } from '../../directives/table-directive';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { CardType } from '../../app/models/CardType';
import { Customer } from '../../app/models/Customer';
import { User } from '../../app/models/User';
import { TranslateService } from '../../../node_modules/@ngx-translate/core';
import { AlertsHolder } from '../../app/models/AlertsHolder';
import { Storage } from '../../../node_modules/@ionic/storage';
import { PoS } from '../../app/models/PoS';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { Config } from '../../providers/config';
import { ConfigService } from '../../providers/config/config.service';
import { AuthenticationService } from '../../providers/authentication/authenticationService';
import { AccountHolder } from '../../app/models/AccountHolder';
import { RegisterActivity } from '../../app/models/RegisterActivity';
import { LookalikeCardCreation } from '../../app/models/LookalikeCardCreation';
import { Coupon } from '../../app/models/Coupon';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

@Component({
  selector: 'page-current-account-details',
  templateUrl: 'current-account-details.html',
})
export class CurrentAccountDetailsPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('cardModal')
  private cardModal: ModalDirective;

  @ViewChild('insertCardModal')
  private insertCardModal: ModalDirective;

  @ViewChild('retypePinModal')
  private retypePinModal: ModalDirective;

  @ViewChild('cardForm')
  private cardForm: NgForm;

  @ViewChild('retypePinForm')
  private retypePinForm: NgForm;

  private pageName: string = 'page-current-account-details';

  private currentAccount: CurrentAccount;
  private currentAccountUuid: string;
  private currentCard = new Card();
  private cardTypes: CardType[];
  private edit = false;
  private service = false;
  private pos: PoS;
  private activDate = new Date();
  private expirDate = new Date();
  private fistTimeAccess = true;
  private userRole: string;

  private alertsHolder: AlertsHolder;
  private statuses = CardStatus;
  private notes = CardBlockReason;
  private accountOwner;
  private accountOwnerType;
  private closedActivity;
  private noActiveServiceCard;

  private navControllerService: NavControllerService;
  public bsConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  private currentConfiguration: Config;
  private writingOnCard = false;

  cardOwnerPin: string;
  cardOwnerPin2: string;

  private cardReaderWebSocket: WebSocket;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private authenticationService: AuthenticationService,
    private utils: Utils,
    private app: App,
    public storage: Storage,
    private configService: ConfigService,
    private translate: TranslateService
  ) {
    this.currentAccount = new CurrentAccount();
    this.currentAccountUuid = navParams.get('currentAccountUuid');
    this.navControllerService = new NavControllerService(app, storage);
    this.alertsHolder = new AlertsHolder(translate);
    this.currentConfiguration = this.configService.getConfiguration();
    this.storage.get('PoS').then((pos: PoS) => {
      this.pos = pos;
    });
    this.storage.get('registerActivity').then((activity: RegisterActivity) => {
      this.closedActivity = !activity || activity.closeDate;
    });
    this.storage.get('userRole').then((userRole) => {
      this.userRole = userRole;
    });
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.bsConfig = this.currentConfiguration.datepickerConfig;
    this.loadCurrentAccount();
  }
  ngAfterViewInit(): void {}
  ngOnDestroy(): void {
    if (this.cardReaderWebSocket) {
      this.cardReaderWebSocket.close();
    }
  }

  private loadCurrentAccount() {
    this.backendService.getCurrentAccount(this.currentAccountUuid).subscribe(
      (currentAccount: CurrentAccount) => {
        this.utils.reformatAllCurrentAccountInputDateStrings(currentAccount);
        this.currentAccount = currentAccount;
        this.accountOwnerType = AccountHolder[currentAccount.accountHolderType];
        switch (this.currentAccount.accountHolderType.toString()) {
          case 'Customer':
            this.service = false;
            break;
          case 'User':
            this.service = true;
            this.noActiveServiceCard = this.currentAccount.cards.some(
              (card) => CardStatus[card.status] == CardStatus.Active.toString()
            );
            break;
        }
        this.loadCardTypes();
        this.loadAccountOwner();
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadCardTypes() {
    this.userRole = this.userRole;
    this.backendService.getCardTypes(this.service, true).subscribe(
      (cardTypes: CardType[]) => {
        this.cardTypes = cardTypes.filter(
          (type) => (type.name === 'Installatore' && this.userRole === 'ROLE_SETUP') || type.name !== 'Installatore'
        );
        if (this.currentAccount.cards.length == 0 && this.fistTimeAccess) {
          this.addCard();
          this.fistTimeAccess = false;
        }
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadAccountOwner() {
    this.backendService.getOwnerByCurrentAccount(this.currentAccount).subscribe(
      (owner: Customer | User) => {
        this.accountOwner = owner;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  submitCard(btnEvent: HTMLButtonElement, showCouponsPage?: boolean) {
    btnEvent.disabled = true;
    this.cardOwnerPin = null;
    this.cardOwnerPin2 = null;
    if (this.edit && this.utils.isSecondCircuit(this.currentCard)) {
      btnEvent.disabled = true;
      this.currentCard.currentAccountUuid = this.currentAccount.uuid;
      this.currentCard.posUuid = this.pos && this.pos.uuid;
      this.currentCard.activationDate = this.activDate.toISOString();
      this.currentCard.expirationDate = this.expirDate ? this.expirDate.toISOString() : null;
      this.backendService
        .saveOrUpdateCard(this.currentCard)
        .subscribe(
          (card) => {
            this.currentCard = card;
            this.table.refreshTable();
            this.alertsHolder.show('Card succesfully modified.', 'success');
          },
          (err: HttpErrorResponse) => {}
        )
        .add(() => {
          this.closeCardModal();
          btnEvent.disabled = false;
        });
    } else if (this.edit || this.currentAccount.accountHolderType.toString() == AccountHolder[AccountHolder.Customer]) {
      if (this.cardReaderWebSocket) {
        this.cardReaderWebSocket.close();
      }
      let webSocket: WebSocket = (this.cardReaderWebSocket = new WebSocket(
        this.configService.getCardReaderWebSocketUrl()
      ));
      webSocket.addEventListener('error', (ev: Event) => {
        if (webSocket.readyState == WebSocket.CLOSED) {
          this.alertsHolder.show('Card reader not found. Set it up and retry.', 'danger');
        } else if (webSocket.readyState == WebSocket.CONNECTING) {
          this.alertsHolder.show('Card reader still connecting. Please wait.', 'danger');
        } else {
          this.alertsHolder.show('Error while reading the card.', 'danger');
          console.error('Card reader error', ev);
        }
        btnEvent.disabled = false;
      });
      if (this.edit) {
        webSocket.addEventListener('message', (ev: MessageEvent) => {
          let evData: any = JSON.parse(ev.data);
          switch (evData.messageType) {
            case 'event':
              switch (evData.message.event) {
                case 'UNPROTECTED_CARD_DETECTED':
                  this.alertsHolder.show('Wrong card.', 'danger');
                  this.sendCardReaderHaltCommand(webSocket);
                  webSocket.close();
                  this.closeInsertCardModal();
                  btnEvent.disabled = false;
                  break;
                case 'CARD_DETECTED':
                  this.writingOnCard = true;
                  if (evData.message.values.cardId == this.currentCard.uuid) {
                    this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                    this.currentCard.posUuid = this.pos && this.pos.uuid;
                    this.currentCard.activationDate = this.activDate.toISOString();
                    this.currentCard.expirationDate = this.expirDate ? this.expirDate.toISOString() : null;
                    this.backendService.saveOrUpdateCard(this.currentCard).subscribe(
                      (card) => {
                        this.currentCard = card;
                        this.table.refreshTable();
                        this.sendCardReaderWriteValuesCommand(webSocket, card);
                      },
                      (err: HttpErrorResponse) => {
                        this.cleanUpAfterCardWrite(webSocket, btnEvent);
                      }
                    );
                  } else {
                    this.alertsHolder.show('Wrong card.', 'danger');
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                    this.closeInsertCardModal();
                    btnEvent.disabled = false;
                  }
                  break;
              }
              break;
            case 'command-response':
              switch (evData.message.request.command) {
                case 'WRITE_VALUES':
                  if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                    this.alertsHolder.show('Card succesfully modified.', 'success');
                    this.writingOnCard = false;
                    this.cleanUpAfterCardWrite(webSocket, btnEvent);
                  }
                  break;
              }
              break;
            case 'command-error':
              switch (evData.message.request.command) {
                case 'WRITE_VALUES':
                  if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                    if (evData.message.request.parameters.cardStatus == 'Blocked') {
                      this.sendCardReaderHaltCommand(webSocket);
                      webSocket.close();
                    } else {
                      this.alertsHolder.show('Card write error.', 'danger');
                      this.currentCard.status = CardStatus.Blocked;
                      this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                      this.backendService.saveOrUpdateCard(this.currentCard).subscribe(
                        (card: Card) => {
                          this.currentCard = card;
                          this.alertsHolder.show('The card was automatically blocked.', 'danger');
                        },
                        (error: any) => {
                          console.error(error);
                          this.alertsHolder.show('Do not use the card again. Block it manually.', 'danger');
                        }
                      );
                      this.sendBlockedCardStatusCardReaderWriteValuesCommand(webSocket, this.currentCard);
                      this.closeCardModal();
                      this.closeRetypePinModal();
                      this.closeInsertCardModal();
                      this.cardOwnerPin = null;
                      this.cardOwnerPin2 = null;
                      btnEvent.disabled = false;
                    }
                  }
                  break;
              }
              break;
          }
        });
      } else {
        this.backendService.getOwnerByCurrentAccount(this.currentAccount).subscribe(
          (owner: Customer) => {
            webSocket.addEventListener('message', (ev: MessageEvent) => {
              let evData: any = JSON.parse(ev.data);
              switch (evData.messageType) {
                case 'event':
                  switch (evData.message.event) {
                    case 'UNPROTECTED_CARD_DETECTED':
                    case 'CARD_DETECTED':
                      this.writingOnCard = true;
                      this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                      this.currentCard.posUuid = this.pos && this.pos.uuid;
                      this.currentCard.activationDate = this.activDate.toISOString();
                      this.currentCard.expirationDate = this.expirDate ? this.expirDate.toISOString() : null;
                      this.backendService.saveOrUpdateCard(this.currentCard).subscribe(
                        (card) => {
                          this.currentCard = card;
                          this.backendService.getCardTransactionsByCard(card).subscribe((transactionList) => {
                            const card =
                              transactionList.length === 1 &&
                              transactionList.find((item) => item.type && item.type.toString() === 'Recharge');
                            if (card) {
                              this.backendService.getCardTransactionReceiptPdf(card).subscribe(
                                (blob: Blob) => {
                                  const element = document.createElement('a');
                                  element.href = URL.createObjectURL(blob);
                                  const date = moment().format('DD-MM-YYYY, h:mm:ss');
                                  element.download = card.type + ' ' + date + '.pdf';
                                  document.body.appendChild(element);
                                  element.click();
                                },
                                (err: HttpErrorResponse) => {
                                  console.error('Error pdf creation', err);
                                }
                              );
                            }
                          });
                          this.table.refreshTable();
                          this.sendCardReaderFormatCardCommand(webSocket, card, this.currentAccount, owner, null, null);
                        },
                        (err: HttpErrorResponse) => {
                          let errorMessage;
                          if (err.error.codeNumber === 'APP-027') {
                            errorMessage = "Plafond over organization limit";
                          } else {
                            errorMessage = 'Server error.';
                          }
                          this.alertsHolder.show(errorMessage, 'danger');
                          this.cleanUpAfterCardWrite(webSocket, btnEvent);
                        }
                      );
                      break;
                  }
                  break;
                case 'command-response':
                  switch (evData.message.request.command) {
                    case 'FORMAT_CARD':
                      if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                        this.alertsHolder.show('Card succesfully created.', 'success');
                        showCouponsPage && this.showCouponsPage(this.currentCard);
                        this.cleanUpAfterCardWrite(webSocket, btnEvent);
                        this.writingOnCard = false;
                      }
                      break;
                  }
                  break;
                case 'command-error':
                  switch (evData.message.request.command) {
                    case 'FORMAT_CARD':
                      if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                        this.alertsHolder.show('Card write error.', 'danger');
                        this.currentCard.status = CardStatus.Blocked;
                        this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                        this.backendService
                          .saveOrUpdateCard(this.currentCard)
                          .subscribe(
                            (card: Card) => {
                              this.currentCard = card;
                              this.alertsHolder.show('The card was automatically blocked.', 'danger');
                            },
                            (error: any) => {
                              console.error(error);
                              this.alertsHolder.show('Do not use the card again. Block it manually.', 'danger');
                            }
                          )
                          .add(() => {
                            this.cleanUpAfterCardWrite(webSocket, btnEvent);
                          });
                      }
                      break;
                  }
                  break;
              }
            });
          },
          (err: HttpErrorResponse) => {
            this.alertsHolder.show('Server error.', 'danger');
            this.cleanUpAfterCardWrite(webSocket, btnEvent);
          }
        );
      }
      this.cardReaderWebSocket.addEventListener('open', (ev: Event) => {
        this.sendCardReaderHaltCommand(webSocket);
        this.showInsertCardModal(btnEvent);
      });
    } else if (this.currentAccount.accountHolderType.toString() == AccountHolder[AccountHolder.User]) {
      this.showRetypePinModal(btnEvent, showCouponsPage);
    }
  }

  submitPin(
    submitBtn: HTMLButtonElement,
    submitPinBtn: HTMLButtonElement,
    showCouponsPage?: boolean,
    isLookalikeCreation?: boolean
  ) {
    submitBtn.disabled = true;
    submitPinBtn.disabled = true;
    this.backendService.getOwnerByCurrentAccount(this.currentAccount).subscribe(
      (user: User) => {
        this.authenticationService.checkPin(user.userName, this.cardOwnerPin).subscribe(
          (response) => {
            let token = response && response.token;
            if (token) {
              this.cardReaderWebSocket = new WebSocket(this.configService.getCardReaderWebSocketUrl());
              this.cardReaderWebSocket.addEventListener('error', (ev: Event) => {
                if (this.cardReaderWebSocket.readyState == WebSocket.CLOSED) {
                  this.alertsHolder.show('Card reader not found. Set it up and retry.', 'danger');
                } else if (this.cardReaderWebSocket.readyState == WebSocket.CONNECTING) {
                  this.alertsHolder.show('Card reader still connecting. Please wait.', 'danger');
                } else {
                  this.alertsHolder.show('Error while reading the card.', 'danger');
                  console.error('Card reader error', ev);
                }
                this.closeRetypePinModal();
                this.cardOwnerPin = null;
                this.cardOwnerPin2 = null;
                submitBtn.disabled = false;
                submitPinBtn.disabled = false;
              });
              let messageEventListener: (this: WebSocket, ev: WebSocketEventMap['message']) => any;
              if (isLookalikeCreation) {
                messageEventListener = (ev: MessageEvent) => {
                  let evData: any = JSON.parse(ev.data);
                  switch (evData.messageType) {
                    case 'event':
                      switch (evData.message.event) {
                        case 'UNPROTECTED_CARD_DETECTED':
                        case 'CARD_DETECTED':
                          let lookalikeCard: { posUuid: string; activationDate: string } = {
                            posUuid: this.pos && this.pos.uuid,
                            activationDate: new Date().toISOString(),
                          };
                          this.backendService.createLookalikeCard(this.currentCard.uuid, lookalikeCard).subscribe(
                            (lookalikeCardCreation: LookalikeCardCreation) => {
                              this.currentCard = lookalikeCardCreation.card;
                              this.table.refreshTable();
                              this.sendCardReaderFormatCardCommand(
                                this.cardReaderWebSocket,
                                lookalikeCardCreation.card,
                                this.currentAccount,
                                user,
                                this.cardOwnerPin,
                                lookalikeCardCreation.coupons
                              );
                            },
                            (err: HttpErrorResponse) => {
                              this.alertsHolder.show('Server error.', 'danger');
                              this.cleanUpAfterCardWrite(this.cardReaderWebSocket);
                              submitPinBtn.disabled = false;
                            }
                          );
                          break;
                      }
                      break;
                    case 'command-response':
                      switch (evData.message.request.command) {
                        case 'FORMAT_CARD':
                          if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                            this.alertsHolder.show('Card succesfully created.', 'success');
                            showCouponsPage && this.showCouponsPage(this.currentCard);
                            this.cleanUpAfterCardWrite(this.cardReaderWebSocket, submitBtn);
                            submitPinBtn.disabled = false;
                          }
                          break;
                      }
                      break;
                    case 'command-error':
                      switch (evData.message.request.command) {
                        case 'FORMAT_CARD':
                          if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                            this.alertsHolder.show('Card write error.', 'danger');
                            this.currentCard.status = CardStatus.Blocked;
                            this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                            this.backendService
                              .saveOrUpdateCard(this.currentCard)
                              .subscribe(
                                (card: Card) => {
                                  this.currentCard = card;
                                  this.alertsHolder.show('The card was automatically blocked.', 'danger');
                                },
                                (error: any) => {
                                  console.error(error);
                                  this.alertsHolder.show('Do not use the card again. Block it manually.', 'danger');
                                }
                              )
                              .add(() => {
                                this.cleanUpAfterCardWrite(this.cardReaderWebSocket, submitBtn);
                                submitPinBtn.disabled = false;
                              });
                          }
                          break;
                      }
                      break;
                  }
                };
              } else {
                messageEventListener = (ev: MessageEvent) => {
                  let evData: any = JSON.parse(ev.data);
                  switch (evData.messageType) {
                    case 'event':
                      switch (evData.message.event) {
                        case 'UNPROTECTED_CARD_DETECTED':
                        case 'CARD_DETECTED':
                          this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                          this.currentCard.posUuid = this.pos && this.pos.uuid;
                          this.currentCard.activationDate = this.activDate.toISOString();
                          this.currentCard.expirationDate = this.expirDate ? this.expirDate.toISOString() : null;
                          this.backendService.saveOrUpdateCard(this.currentCard).subscribe(
                            (card) => {
                              this.currentCard = card;
                              this.table.refreshTable();
                              this.sendCardReaderFormatCardCommand(
                                this.cardReaderWebSocket,
                                card,
                                this.currentAccount,
                                user,
                                this.cardOwnerPin,
                                null
                              );
                            },
                            (err: HttpErrorResponse) => {
                              this.cleanUpAfterCardWrite(this.cardReaderWebSocket, submitBtn);
                              submitPinBtn.disabled = false;
                            }
                          );
                          break;
                      }
                      break;
                    case 'command-response':
                      switch (evData.message.request.command) {
                        case 'FORMAT_CARD':
                          if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                            this.alertsHolder.show('Card succesfully created.', 'success');
                            showCouponsPage && this.showCouponsPage(this.currentCard);
                            this.cleanUpAfterCardWrite(this.cardReaderWebSocket, submitBtn);
                            submitPinBtn.disabled = false;
                          }
                          break;
                      }
                      break;
                    case 'command-error':
                      switch (evData.message.request.command) {
                        case 'FORMAT_CARD':
                          if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                            this.alertsHolder.show('Card write error.', 'danger');
                            this.currentCard.status = CardStatus.Blocked;
                            this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                            this.backendService
                              .saveOrUpdateCard(this.currentCard)
                              .subscribe(
                                (card: Card) => {
                                  this.currentCard = card;
                                  this.alertsHolder.show('The card was automatically blocked.', 'danger');
                                },
                                (error: any) => {
                                  console.error(error);
                                  this.alertsHolder.show('Do not use the card again. Block it manually.', 'danger');
                                }
                              )
                              .add(() => {
                                this.cleanUpAfterCardWrite(this.cardReaderWebSocket, submitBtn);
                                submitPinBtn.disabled = false;
                              });
                          }
                          break;
                      }
                      break;
                  }
                };
              }
              this.cardReaderWebSocket.addEventListener('message', messageEventListener);
              this.cardReaderWebSocket.addEventListener('open', (ev: Event) => {
                this.sendCardReaderHaltCommand(this.cardReaderWebSocket);
                this.showInsertCardModal(submitPinBtn);
              });
            } else {
              this.alertsHolder.show('Wrong PIN.', 'danger');
              this.cleanUpOnCheckPinError(submitBtn, submitPinBtn);
            }
          },
          (err: HttpErrorResponse) => {
            this.alertsHolder.show('Problems while checking the PIN.', 'danger');

            this.cleanUpOnCheckPinError(submitBtn, submitPinBtn);
          }
        );
      },
      (err: HttpErrorResponse) => {
        this.alertsHolder.show('Problems while checking the PIN.', 'danger');

        this.cleanUpOnCheckPinError(submitBtn, submitPinBtn);
      }
    );
  }

  editWithoutCard(submitBtn: HTMLButtonElement) {
    this.closeInsertCardModal();
    this.cardReaderWebSocket.close();
    this.currentCard.currentAccountUuid = this.currentAccount.uuid;
    this.currentCard.posUuid = this.pos ? this.pos.uuid : null;
    this.currentCard.activationDate = this.activDate.toISOString();
    this.currentCard.expirationDate = this.expirDate ? this.expirDate.toISOString() : null;
    this.backendService
      .saveOrUpdateCard(this.currentCard)
      .subscribe(
        (card) => {
          this.currentCard = card;
          this.table.refreshTable();
          this.alertsHolder.show('Card succesfully modified.', 'success');
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        this.closeCardModal();
        submitBtn.disabled = false;
      });
  }

  private cleanUpOnCheckPinError(submitBtn: HTMLButtonElement, submitPinBtn: HTMLButtonElement) {
    this.closeCardModal();
    this.closeRetypePinModal();
    this.cardOwnerPin = null;
    this.cardOwnerPin2 = null;
    submitBtn.disabled = false;
    submitPinBtn.disabled = false;
  }

  private cleanUpAfterCardWrite(cardReaderWebSocket: WebSocket, btnEvent?: HTMLButtonElement) {
    this.closeCardModal();
    this.closeRetypePinModal();
    this.closeInsertCardModal();
    this.cardOwnerPin = null;
    this.cardOwnerPin2 = null;
    btnEvent && (btnEvent.disabled = false);
    this.sendCardReaderHaltCommand(cardReaderWebSocket);
    cardReaderWebSocket.close();
  }

  private sendCardReaderHaltCommand(cardReaderWebSocket: WebSocket) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'HALT',
        },
      })
    );
  }

  private sendCardReaderFormatCardCommand(
    cardReaderWebSocket: WebSocket,
    card: Card,
    currentAccount: CurrentAccount,
    owner: Customer | User,
    pin: string,
    coupons: Coupon[]
  ) {
    let initialBalance: Number = card.initialAmount ? card.initialAmount : card.balance;
    let balanceCents: number = this.utils.toCents(initialBalance.valueOf());
    let activationDate: Date = new Date(card.activationDate);
    let activationTime: string = activationDate.toISOString();
    let expirationDate: Date = new Date(card.expirationDate);
    let expireTime: string = expirationDate.toISOString();
    let plafond = this.utils.toCents((card.secondCircuitPlafond || card.plafond).valueOf());
    let message: any = {
      messageType: 'command',
      message: {
        command: 'FORMAT_CARD',
        parameters: {
          cardId: card.uuid,
          activationTime: activationTime,
          expireTime: expireTime,
          cardType: card.type.name,
          pin: pin,
          userId: owner.uuid,
          cardId2: card.secondCircuitUuid,
          balance: {
            amount: balanceCents,
            version: card.balanceVersion,
          },
          cardStatus: card.status,
          cardName: card.name,
          plafond: plafond,
          ownerFirstName: owner.firstName,
          ownerLastName: owner.lastName,
        },
      },
    };
    if (currentAccount.room) {
      message.message.parameters.roomNumber = currentAccount.room;
    }
    if (card.initialRecharge) {
      let lastTransactionAmountCents = this.utils.toCents(card.initialRecharge.movement.valueOf());
      message.message.parameters.lastTransaction = {
        id: card.initialRecharge.uuid,
        posId: card.initialRecharge.pos.uuid,
        amount: lastTransactionAmountCents,
        type: card.initialRecharge.type,
      };
    }
    if (coupons && coupons.length > 0) {
      let plainCoupons: Coupon[] = [];
      let dailyCoupons: Coupon[] = [];
      coupons.forEach((value: Coupon) => {
        if (value.type.daily) {
          dailyCoupons.push(value);
        } else {
          plainCoupons.push(value);
        }
      });
      let couponsMessageValue: any[] = [];
      plainCoupons.forEach((coupon: Coupon) => {
        couponsMessageValue.push({
          code: coupon.type.code,
          amount: coupon.amount,
        });
      });
      message.message.parameters.coupons = couponsMessageValue;
      dailyCoupons.sort((a: Coupon, b: Coupon) => {
        let result = a.type.code - b.type.code;
        if (result == 0) {
          result = a.date - b.date;
        }
        return result;
      });
      let dailyCouponsMessageValue: any[] = [];
      let currentCode: number;
      let dailyAmounts: any[];
      dailyCoupons.forEach((dailyCoupon: Coupon) => {
        if (dailyCoupon.type.code != currentCode) {
          if (currentCode) {
            dailyCouponsMessageValue.push({
              code: currentCode,
              dailyAmounts: dailyAmounts,
            });
          }
          dailyAmounts = [];
          currentCode = dailyCoupon.type.code;
        }
        let dayOfStay: number = this.dailyCouponDateToDayOfStay(
          new Date(this.currentCard.activationDate),
          new Date(this.currentCard.expirationDate),
          new Date(dailyCoupon.date)
        );
        let dailyAmount: any = {
          dayOfStay: dayOfStay,
          amount: dailyCoupon.amount,
        };
        dailyAmounts.push(dailyAmount);
      });
      if (currentCode) {
        dailyCouponsMessageValue.push({
          code: currentCode,
          dailyAmounts: dailyAmounts,
        });
      }
      message.message.parameters.dailyCoupons = dailyCouponsMessageValue;
    }
    cardReaderWebSocket.send(JSON.stringify(message));
  }

  private sendCardReaderWriteValuesCommand(cardReaderWebSocket: WebSocket, card: Card) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            cardStatus: card.status,
          },
        },
      })
    );
  }

  private sendBlockedCardStatusCardReaderWriteValuesCommand(cardReaderWebSocket: WebSocket, card: Card) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            cardStatus: 'Blocked',
          },
        },
      })
    );
  }

  submitAndShowCouponPage(btnEvent: HTMLButtonElement) {
    this.submitCard(btnEvent, true);
  }

  addCard() {
    this.currentCard = new Card();
    this.cardForm.resetForm(this.currentCard);
    this.currentCard.type = this.cardTypes[0];
    this.activDate = new Date();
    this.edit = false;
    this.showCardModal();
  }

  editCard(card) {
    this.currentCard = card;
    this.edit = true;
    this.activDate = new Date(this.currentCard.activationDate);
    this.expirDate = this.currentCard.expirationDate ? new Date(this.currentCard.expirationDate) : null;
    this.showCardModal();
  }

  showCardModal() {
    this.utils.reformatAllCardInputDateStrings(this.currentCard);
    this.cardOwnerPin = null;
    this.cardOwnerPin2 = null;
    this.cardModal.show();
  }

  closeCardModal() {
    this.cardModal.hide();
    this.currentCard = new Card();
    this.loadCurrentAccount();
  }

  showInsertCardModal(buttonToEnableOnCancel?: HTMLButtonElement) {
    this.insertCardModal['buttonToEnableOnClose'] = buttonToEnableOnCancel;
    this.insertCardModal.show();
  }

  closeInsertCardModal() {
    if (this.insertCardModal['buttonToEnableOnClose']) {
      (<HTMLButtonElement>this.insertCardModal['buttonToEnableOnClose']).disabled = false;
    }
    delete this.insertCardModal['buttonToEnableOnClose'];
    this.insertCardModal.hide();
  }

  showRetypePinModal(btnEvent?: HTMLButtonElement, showCouponsPage?: boolean, isLookalikeCreation?: boolean) {
    if (btnEvent) {
      btnEvent.disabled = true;
      this.retypePinModal['buttonToEnableOnClose'] = btnEvent;
    }
    this.cardOwnerPin = null;
    this.cardOwnerPin2 = null;
    this.retypePinForm.resetForm();
    if (showCouponsPage) {
      this.retypePinModal['showCouponsPage'] = showCouponsPage;
    } else {
      delete this.retypePinModal['showCouponsPage'];
    }
    if (isLookalikeCreation) {
      this.retypePinModal['isLookalikeCreation'] = isLookalikeCreation;
    } else {
      delete this.retypePinModal['isLookalikeCreation'];
    }
    this.retypePinModal.show();
  }

  closeRetypePinModal() {
    if (this.retypePinModal['buttonToEnableOnClose']) {
      (<HTMLButtonElement>this.retypePinModal['buttonToEnableOnClose']).disabled = false;
    }
    delete this.insertCardModal['buttonToEnableOnClose'];
    delete this.retypePinModal['isLookalikeCreation'];
    delete this.retypePinModal['showCouponsPage'];
    this.retypePinModal.hide();
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  onStatusChange(status) {
    if (CardStatus[status] == CardStatus.Active.toString()) {
      this.currentCard.notes = '';
      this.currentCard.blacklisted = false;
    }
    if (CardStatus[status] == CardStatus.Inactive.toString() || CardStatus[status] == CardStatus.Blocked.toString()) {
      this.currentCard.notes = CardBlockReason[CardBlockReason.BlockedCard];
      this.currentCard.blacklisted = true;
    }
  }

  showAccountsOwnersPage() {
    this.navControllerService.showAccountsOwnersPage(this.accountOwnerType);
  }

  showCardDetails(card: Card) {
    this.navControllerService.showCardDetails(card.uuid, this.accountOwnerType);
  }

  showCouponsPage(card) {
    this.navControllerService.showCouponsPage(card.uuid);
  }

  showPrintCardPage(card) {
    this.navControllerService.showPrintCardPage(card.uuid);
  }

  showAccountsOwnerDetails() {
    this.accountOwner &&
      this.navControllerService.showAccountsOwnerDetails(this.accountOwner.uuid, this.accountOwnerType);
  }

  cancelInsertCard() {
    this.cardReaderWebSocket.close();
    this.closeInsertCardModal();
  }

  isCreateLookalikeEnabled(card: Card): boolean {
    let currentCardStatus: any = card['status'];
    let isCardCloned: boolean = card['cloned'];
    let isSecondCircuit: boolean = card.type.name == 'Iron' && card.type.credit;
    return (
      !isCardCloned && !isSecondCircuit && currentCardStatus == 'Blocked' && new Date() < new Date(card.expirationDate)
    );
  }

  createLookalike(card: Card) {
    this.edit = false;
    this.cardOwnerPin = null;
    this.cardOwnerPin2 = null;
    if (this.currentAccount.accountHolderType.toString() == AccountHolder[AccountHolder.Customer]) {
      if (this.cardReaderWebSocket) {
        this.cardReaderWebSocket.close();
      }
      let webSocket: WebSocket = (this.cardReaderWebSocket = new WebSocket(
        this.configService.getCardReaderWebSocketUrl()
      ));
      webSocket.addEventListener('error', (ev: Event) => {
        if (webSocket.readyState == WebSocket.CLOSED) {
          this.alertsHolder.show('Card reader not found. Set it up and retry.', 'danger');
        } else if (webSocket.readyState == WebSocket.CONNECTING) {
          this.alertsHolder.show('Card reader still connecting. Please wait.', 'danger');
        } else {
          this.alertsHolder.show('Error while reading the card.', 'danger');
          console.error('Card reader error', ev);
        }
      });
      this.backendService.getOwnerByCurrentAccount(this.currentAccount).subscribe(
        (owner: Customer) => {
          webSocket.addEventListener('message', (ev: MessageEvent) => {
            let evData: any = JSON.parse(ev.data);
            switch (evData.messageType) {
              case 'event':
                switch (evData.message.event) {
                  case 'UNPROTECTED_CARD_DETECTED':
                  case 'CARD_DETECTED':
                    this.writingOnCard = true;
                    let lookalikeCard: { posUuid: string; activationDate: string } = {
                      posUuid: this.pos && this.pos.uuid,
                      activationDate: new Date().toISOString(),
                    };
                    this.backendService.createLookalikeCard(card.uuid, lookalikeCard).subscribe(
                      (lookalikeCardCreation: LookalikeCardCreation) => {
                        this.currentCard = lookalikeCardCreation.card;
                        this.table.refreshTable();
                        this.sendCardReaderFormatCardCommand(
                          webSocket,
                          lookalikeCardCreation.card,
                          this.currentAccount,
                          owner,
                          null,
                          lookalikeCardCreation.coupons
                        );
                      },
                      (err: HttpErrorResponse) => {
                        this.alertsHolder.show('Server error.', 'danger');
                        this.cleanUpAfterCardWrite(webSocket);
                      }
                    );
                    break;
                }
                break;
              case 'command-response':
                switch (evData.message.request.command) {
                  case 'FORMAT_CARD':
                    if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                      this.alertsHolder.show('Card succesfully created.', 'success');
                      this.cleanUpAfterCardWrite(webSocket);
                      this.writingOnCard = false;
                    }
                    break;
                }
                break;
              case 'command-error':
                switch (evData.message.request.command) {
                  case 'FORMAT_CARD':
                    if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                      this.alertsHolder.show('Card write error.', 'danger');
                      this.currentCard.status = CardStatus.Blocked;
                      this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                      this.backendService
                        .saveOrUpdateCard(this.currentCard)
                        .subscribe(
                          (card: Card) => {
                            this.currentCard = card;
                            this.alertsHolder.show('The card was automatically blocked.', 'danger');
                          },
                          (error: any) => {
                            console.error(error);
                            this.alertsHolder.show('Do not use the card again. Block it manually.', 'danger');
                          }
                        )
                        .add(() => {
                          this.cleanUpAfterCardWrite(webSocket);
                        });
                    }
                    break;
                }
                break;
            }
          });
        },
        (err: HttpErrorResponse) => {
          this.alertsHolder.show('Server error.', 'danger');
          this.cleanUpAfterCardWrite(webSocket);
        }
      );
      this.cardReaderWebSocket.addEventListener('open', (ev: Event) => {
        this.sendCardReaderHaltCommand(webSocket);
        this.showInsertCardModal();
      });
    } else if (this.currentAccount.accountHolderType.toString() == AccountHolder[AccountHolder.User]) {
      this.currentCard = card;
      this.showRetypePinModal(null, false, true);
    }
  }

  private dailyCouponDateToDayOfStay(
    cardActivationDate: Date,
    cardExpirationDate: Date,
    dailyCouponDate: Date
  ): number {
    let dayOfStay: number;
    let dummyDate: Date;
    for (let i: number = 0; !dayOfStay && (!dummyDate || cardExpirationDate >= dummyDate); i++) {
      dummyDate = new Date(cardActivationDate.getTime());
      dummyDate.setDate(dummyDate.getDate() + i);
      if (dummyDate.toDateString() == dailyCouponDate.toDateString()) {
        dayOfStay = i + 1;
      }
    }
    return dayOfStay;
  }

  getTitle(msg: string) {
    return this.translate.instant(msg);
  }

  isAdditionalCircuitCredit(cardType: CardType): boolean {
    return !!cardType.additionalCircuits && !!cardType.additionalCircuits.find((c: CardType) => !!c.credit);
  }
}



// WEBPACK FOOTER //
// ./src/pages/current-account-details/current-account-details.ts